import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import parseJsonContent from "../../Utils/parseJsonContent";

function SingleAboutItemPage({ store }) {
    const location = useLocation();
    const navigate = useNavigate();

    const aboutDetails = location?.state;

    console.log("aboutDetails", aboutDetails, store);

    useEffect(() => {
        if (!aboutDetails) {
            navigate("/about");
        }
    }, [aboutDetails, navigate]);

    let exampleContent = `**{size:18}Advantage Loyalty Program – Terms and Conditions{size:end}**  
{size:14}Effective Date: [Insert Date]{size:end}  

Welcome to the Advantage Loyalty Program (“Program”) by Aswaq. These Terms and Conditions govern your participation in the Program. By registering or using the Program through the Advantage app, you agree to these Terms.  

**1. Eligibility**  
You must be at least 18 years old to join.  
A valid mobile number and an active Advantage app account are required.  
Membership is limited to one account per individual.  

**2. Earning Points**  
To earn loyalty points on your purchases:  
Open the Advantage app and locate your unique barcode at the top of the home page.  
Show the barcode to the Aswaq cashier at the time of checkout.  
The cashier will scan your barcode at the POS (Point of Sale) machine.  
Points are added to your account automatically based on your invoice amount.  
You can view your updated points balance on your app's home page.  

**3. Redeeming Points**  
To use your accumulated points:  
Open the Advantage app and check your available points.  
Go to the voucher page and create a voucher based on your points eligibility.  
Show the generated e-voucher to the cashier when you're checking out.  
The cashier will scan the e-voucher from your phone, and the voucher amount will be deducted from your bill.  
Once the voucher is created, the corresponding points will be automatically deducted from your total points.  

**4. Voucher Rules**  
Vouchers are non-transferable and cannot be exchanged for cash.  
Vouchers must be used before their expiration date, if applicable.  
Only one voucher can be used per transaction unless otherwise stated.  

**5. Points Validity**  
Points may have a validity period (e.g., 12 months) and may expire if not used within that time.  
Expired points will not be reinstated.  

**6. Account and Usage**  
Members are responsible for maintaining the confidentiality of their account details.  
Any misuse, tampering, or fraudulent behavior may lead to account suspension or termination.  

**7. Modifications and Termination**  
Aswaq reserves the right to modify or terminate the Program or any part of it at any time without prior notice.  
Changes will be updated in the app or on our official website.  

**8. Privacy Policy**  
Your data is processed in accordance with our Privacy Policy [Insert link if available].  
We do not share your personal data without your consent except as required by law.  

**9. Customer Support**  
For any queries or issues related to the Advantage Loyalty Program, you can contact us at:  

📧 Email: [support@aswaq.com]  
📞 Phone: [+971-XXX-XXXXXX]  `;

    return (
        <AnimatedPage className="overflow-hidden bg-wafaa-white-2">
            <div className="position-sticky z-2">
                <PageTitle name={aboutDetails?.Heading} />
            </div>
            <div className="font-size-13 min-vh-100 bg-wafaa-white-2 text-wafaa-black-1" style={{ textAlign: "justify", padding: "1em" }}>
                {parseJsonContent(aboutDetails?.Content || "")}
            </div>
        </AnimatedPage>
    );
}

export default SingleAboutItemPage;